import React from "react";
import Slider, { SliderThumb } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: "rgba(var(--text-heading-light))",
  height: "1rem",
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: "2rem",
    width: "2rem",
    backgroundColor: "#71B8FF",
    border: "0.15rem solid #fff",
    "&:hover": {
      boxShadow: "none",
    },
    "& .airbnb-bar": {
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: "1rem",
  },
  "& .MuiSlider-rail": {
    color: theme.palette.mode === "dark" ? "#bfbfbf" : "#d8d8d8",
    opacity: theme.palette.mode === "dark" ? undefined : 1,
    height: "1rem",
  },
}));

function Airbnbthumbcomponent(props) {
  return <SliderThumb {...props}></SliderThumb>;
}

function SliderComp(props) {
  const { valueSlider, setValueSlider } = props;
  return (
    <AirbnbSlider
      onChange={(event, newValue) => {
        console.log(newValue);
        setValueSlider(newValue);
      }}
      value={valueSlider}
      thumbcomponent={Airbnbthumbcomponent}
      defaultValue={[2]}
      max={10}
    />
  );
}

export default SliderComp;
